const Promise = require('bluebird');
const platform = require('platform');


/**
 * Вспомогательные методы
 */
class Tools {
	/**
	 * Произвольное логирование
	 * @param object - название объекта, в котором нужно отразить сообщение
	 * @param msg - сообщение
	 */
	static log(object, msg) {
		(object) ? console.error(`[${object}] ${msg}`) : console.error(`${msg}`);
	}

	/**
	 * Получить надомное число от до
	 * @param min
	 * @param max
	 * @returns {*}
	 */
	static getRandomInt(min, max) {
		return Math.floor(Math.random() * (max - min)) + min;
	}

	/**
	 * Отключение возможности выбрать элемент табом
	 * @param items - элемент
	 */
	static disableTab(items) {
		items.each(function () {
			$(this).attr('tabindex', '-1');
		});
	}

	/**
	 * Получить хеш со страницы
	 * @returns {string}
	 */
	static getPageHash() {
		return window.location.hash;
	}

	/**
	 * Задать хеш для страницы
	 * @returns {string}
	 */
	static setPageHash(hash) {
		window.location.hash = hash;
	}

	/**
	 * Разбивает хеш страницы по символу
	 * @param hash
	 * @param delimiter
	 * @returns {Array|*}
	 */
	static divideHashByDelimiter(delimiter = '__') {
		let hash = Tools.getPageHash();
		let splittedHash = String(hash).split(delimiter);

		return splittedHash.map((item, i) => {
			return Tools.clearHashFromHashSymbol(item);
		});
	}

	/**
	 * Возвращает принадлежность браузер к семейству IE9
	 * @returns {boolean}
	 */
	static isIE9() {
		return (platform.name === 'IE' && platform.version === '9.0');
	}

	/**
	 * Возвращает хеш страницы, склеенный по символу
	 * @param hash
	 * @param delimiter
	 * @returns {Array|*}
	 */
	static jointHashByDelimiter(hash = [], delimiter = '__') {
		if (hash.length) {
			let arClearHash = [];

			for (let i in hash) {
				let clearItem = Tools.clearHashFromHashSymbol(hash[i]);
				if (clearItem && clearItem != 'undefined') {
					arClearHash.push(clearItem);
				}
			}

			return '#' + arClearHash.join(delimiter);
		} else {
			return false;
		}
	}

	/**
	 * Сбрасываем хеш
	 */
	static clearPageUrlHash() {
		window.location.hash = '';
	}

	static clearHashFromHashSymbol(hash) {
		return String(hash).replace(/#/g, '');
	}

	static getRotationDegrees(obj) {
		let angle = 0;
		let matrix = obj.css('-webkit-transform') ||
			obj.css('-moz-transform') ||
			obj.css('-ms-transform') ||
			obj.css('-o-transform') ||
			obj.css('transform');

		if (matrix !== 'none') {
			let values = matrix.split('(')[1].split(')')[0].split(',');
			let a = values[0];
			let b = values[1];
			angle = Math.round(Math.atan2(b, a) * (180 / Math.PI));
		}

		if (angle < 0) {
			angle += 360;
		}

		return angle;
	}
}

module.exports = Tools;



// WEBPACK FOOTER //
// ./temp/components/mainpage/classes/Tools.js